import React from "react";
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

const Spinner: React.FC = () => {
    return (
        <Box sx={{ display: 'flex' }}>
            <CircularProgress
                size={'5rem'}
            />
        </Box>
    )
};

export default Spinner;